var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step-block',_vm._g(_vm._b({staticClass:"step-block--material",attrs:{"title":_vm.name,"cover-image":_vm.photo,"attributes":_vm.attributes}},'step-block',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }